import { render, staticRenderFns } from "./offer-layout-single.vue?vue&type=template&id=eb94d79a&scoped=true"
import script from "./offer-layout-single.vue?vue&type=script&lang=js"
export * from "./offer-layout-single.vue?vue&type=script&lang=js"
import style0 from "./offer-layout-single.vue?vue&type=style&index=0&id=eb94d79a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb94d79a",
  null
  
)

export default component.exports